<template>
    <span>
        <popper-view
            :hide-popper-tooltip="hidePopperTooltip"
            @showPopper="showPopper($event)"
            @hidePopper="hidePopper($event)">
            <div
                :id="trimLabel"
                class="popper"
                role="tooltip">
                <div
                    class="close lt4-ex"
                    @click="hidePopper()"></div>
                <div v-html="popperContent"></div>
            </div>
            <label
                v-if="showQuestionMark"
                slot="reference">
                <button
                    class="lt-icons lt4-QuestionOutline calc-question"
                    :aria-label="ariaLabel"
                    :aria-controls="trimLabel"
                    :aria-expanded="AriaExpanded"></button>
            </label>
        </popper-view>
    </span>
</template>

<script>
    import PopperView from './popper-view.vue';

    export default {
        components: {
            PopperView,
        },
        props: {
            label: {
                type: String,
                default: '',
            },
            showQuestionMark: {
                default: false,
            },
            popperContent: {
                default: 'Default Content',
            },
            ariaExpanded: {
                default: 'false',
            },
        },
        data() {
            return {
                hidePopperTooltip: true,
                AriaExpanded: this.ariaExpanded,
                Label: this.label,
            };
        },
        computed: {
            trimLabel() {
                return this.Label.replace(/\s+/g, '-').replace(/:/g, '').toLowerCase();
            },
            ariaLabel() {
                return `View informartion for ${this.Label.replace(/:/g, '').toLowerCase()}`;
            },
        },
        beforeMount() {
            window.addEventListener('keyup', this.onEscapeKeyUp);
        },
        beforeDestroy() {
            window.removeEventListener('keyup', this.onEscapeKeyUp);
        },
        mounted() {
            this.Label = this.label === '' ? 'popper' : this.label;
        },
        methods: {
            showPopper() {
                this.hidePopperTooltip = false;
                this.AriaExpanded = 'true';
            },
            hidePopper() {
                this.hidePopperTooltip = true;
                this.AriaExpanded = 'false';
            },
            onEscapeKeyUp(event) {
                if (event.which === 27) {
                    this.hidePopper();
                }
            },
        },
    };
</script>
